import React from 'react';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
// import {
//   useCurrentDecedentId,
//   useFinishedClosingTasks,
// } from '@/app/providers/DecedentProvider';
// import { Notification } from '@/common/utils/index';
import { useTranslation } from 'react-i18next';
// import { useDownloadFinalReportMutation } from '@/entities/report';
import useLogoutIntentStore from '@/common/stores/logout-intent';
import { routes } from '@/app/routing/index';
import { getProfileMenuConfig } from '@/common/components/NavigationBar/components/config';
import drawerBarStyles from '@/common/components/NavigationBar/DrawerBar.styles';
import { Typography } from '@mui/material';

const Profile = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { user, isLoggingOut } = useAuth();
  // const decedentId = useCurrentDecedentId();
  // const isExportAvailable = useFinishedClosingTasks();
  // const downloadFinalReportMutation = useDownloadFinalReportMutation();
  const requestLogout = useLogoutIntentStore((state) => state.requestLogout);
  const fullName = `${user.firstName} ${user.lastName}`;
  const userEmail = user?.email || '';
  const open = Boolean(anchorEl);
  const isAccountSettingsPage = pathname === routes.dashboard.accountSettings;

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // TODO: Export report is temporarily hidden (EAC-576)
  // const handleExportReport = async () => {
  //   if (!isExportAvailable || downloadFinalReportMutation.isPending) return;

  //   try {
  //     const blob = await downloadFinalReportMutation.mutateAsync(decedentId);
  //     const newBlob = new Blob([blob]);
  //     const blobUrl = window.URL.createObjectURL(newBlob);

  //     let link = document.createElement('a');
  //     link.href = blobUrl;
  //     link.setAttribute('download', 'report.zip');
  //     document.body.appendChild(link);
  //     link.click();
  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(blobUrl);
  //     link = undefined;
  //     handleCloseMenu();
  //   } catch (_error) {
  //     Notification.error(t('Downloading report error'));
  //   }
  // };

  const handleAccountSettings = () => {
    handleCloseMenu();
    history.push(routes.dashboard.accountSettings);
  };

  const handleLogout = () => {
    const nextPath = pathname.includes(routes.adminPanel.index)
      ? routes.adminLogin
      : routes.login;

    handleCloseMenu();
    requestLogout(nextPath);
    history.replace(nextPath);
  };

  const menuItems = getProfileMenuConfig({
    t,
    // onExportReport: handleExportReport,
    onAccountSettings: handleAccountSettings,
    onLogout: handleLogout,
    // isExportDisabled:
    //   !isExportAvailable || downloadFinalReportMutation.isPending,
    isLogoutDisabled: isLoggingOut,
  });

  return (
    <>
      <Button
        color="secondary"
        onClick={handleOpenMenu}
        endIcon={<KeyboardArrowRightIcon sx={{ fontSize: '24px!important' }} />}
        sx={[
          drawerBarStyles.info,
          isAccountSettingsPage && drawerBarStyles.infoActive,
        ]}
      >
        <Box sx={drawerBarStyles.infoContaniner}>
          <Typography variant="subtitle1" sx={drawerBarStyles.infoBodyFullname}>
            {fullName}
          </Typography>
          <Typography variant="body2" sx={drawerBarStyles.infoBodyEmail}>
            {userEmail}
          </Typography>
        </Box>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {menuItems.map(({ key, label, icon, onClick, disabled }) => (
          <MenuItem key={key} onClick={onClick} disabled={disabled}>
            <ListItemIcon>{icon}</ListItemIcon>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default Profile;
